module.exports = __webpack_public_path__ + "static/media/personalizable.08c43c53.svg";